<template>
  <div>
    <auto-menu-layout>
      <annotate-modal
          v-if="showModal && modalAssetId"
          data-testid="auto-suggestions-annotate-modal"
          @close_modal="closeModal"
          @remove_item="onModalRemoveItem"
          :asset_id="modalAssetId"
      ></annotate-modal>
      <row>
        <col3>
          <filter-tree
                :initial_filter="[
                    {'type':11, 'value':'No'},
                    {'type':61, 'value':'No'},
                    {'type':31, 'value':'Yes'}
                  ]"
                @update="update"
                @load="load"
                :max_results="max_results"
                ></filter-tree>
        </col3>
        <col9>
          <row>
            <v-btn v-if="assets.length > 0" @click="accept_all_suggestions_on_page" color="primary">{{$t('suggestions.accept_all_on_page')}}</v-btn>
            <col12 v-for="asset in assets" :key="asset.id">
              <asset-suggestions 
              :asset="asset"
              @remove_asset_from_list="remove_asset_from_list"
              @select_asset="openAnnotateModal"
              ></asset-suggestions>
            </col12>
          </row>
        </col9>
      </row>
    </auto-menu-layout>
  </div>
</template>

<script>

import AutoMenuLayout from "@/components/layout/AutoMenuLayout";
const { v4: uuidV4 } = require('uuid');
import Annotation from "@/classes/annotation";
import AssetSuggestions from "@/components/AssetSuggestions";
import AnnotateModal from "@/components/AnnotateModal";
import AnnotateMixin from "@/mixins/AnnotateMixin";
import FilterTree from "@/components/asset_filter/FilterTree";
import Row from "@/components/layout/Row";
import Col9 from "@/components/layout/Col9";
import Col3 from "@/components/layout/Col3";
import Col12 from "@/components/layout/Col12";
import { blockAnnotateModalOpen, canOpenAnnotateModal } from '@/utils/annotateModalGuard';

export default {
  name: "Suggestions",
  components: {AutoMenuLayout, AssetSuggestions, AnnotateModal, FilterTree, Row, Col9, Col3, Col12},
  mixins: [AnnotateMixin],
  data() {
    return {
      assets: [],
      items_suggestions: [],
      labels: '',
      setting_asset_accept_suggestions: null,
      max_results: false,
      filters: false,
      limit: false,
      loading: false,
      showModal: false,
      modalAssetId: null,
    }
  },
  methods: {
    openAnnotateModal(asset_id) {
      if (!canOpenAnnotateModal()) {
        return;
      }
      if (!asset_id || this.showModal || this.modalAssetId) {
        return;
      }
      this.modalAssetId = asset_id;
      this.showModal = true;
    },
    closeModal() {
      blockAnnotateModalOpen();
      this.modalAssetId = null;
      this.showModal = false;
    },
    onModalRemoveItem(asset_id) {
      this.remove_asset_from_list(asset_id);
      this.closeModal();
    },
    async accept_all_suggestions_on_page() {
      if (this.assets.length !== 0) {
        this.loading = true
        for (const asset of this.assets) {
          await this.$api.asset.accept_suggestions(asset.id, asset.annotation_suggestions.map(suggestion => suggestion.id));
        }
        this.load()
        this.loading = false
      }
    },
    remove_asset_from_list(asset_id) {
      const index = this.assets.findIndex((asset) => asset.id === asset_id);
      if (index !== -1) {
        this.loading = true;
        const newAssets = [...this.assets];
        newAssets.splice(index, 1);
        this.assets = newAssets;
        this.loading = false;
      }
    },
    update(filters, limit) {
      this.filters = filters
      this.limit = limit
    },
    async load(filters, limit) {

      if(!filters) {
        filters = this.filters
        limit = this.limit
      }

      this.assets = [];
      this.loading = true
      let results = await this.$api.asset.filter(filters, limit, { include_count: true })

        let assets = Array.isArray(results) ? results : (results && results.items) || [];
        let total_results = (results && !Array.isArray(results) && results.count != null) ? results.count : assets.length;
        this.max_results = total_results;

        if (assets.length === 0) {
          this.max_results = 0;
          this.loading = false
        }

        for (let i = 0; i < assets.length; i++) {

          let asset = assets[i]

          let asset_data = await this.$api.asset.load(asset.id);

          let annotation_suggestions = asset_data.annotation_suggestions

          let colors = asset_data.colors;
            let annotations = asset_data.annotations.map(annotation => {
              annotation.color_values = colors[i];
              if(annotation.color) {
                annotation.color_values = annotation.color.split(',')
              }
              annotation.type = annotation.type === 1 ? 'box' : 'point'
              return annotation
            })
            let path = this.$api_host + asset_data.path
            this.assets = this.assets.concat({checked: true, id: asset.id, annotations: annotations, path: path, annotation_suggestions: annotation_suggestions});
            if (this.assets.length === total_results) {
              this.loading = false;
            }
        }
    },
    change_current_annotations_to_suggestions() {
      this.annotation_suggestions.forEach(annotation_suggestion => {
        let suggestion = typeof annotation_suggestion.suggestion === 'string'
          ? JSON.parse(annotation_suggestion.suggestion)
          : (annotation_suggestion.suggestion || {});
        if(suggestion.action === 'add_bounding_box') {
          let suggested_label_name = suggestion.label_name
            || suggestion.label
            || (this.labels.find(label => label.id == suggestion.label_id) || {}).name
            || String(suggestion.label_id);
          let id = uuidV4();
          let color = [0,180,0]
          let annotation = new Annotation(id, 'box', suggestion.coords, this.parseSuggestionField(suggestion.confidence), suggested_label_name, color);
          this.addAnnotationClearSelection(annotation)
        }
        else if(suggestion.action === 'add_keypoint') {
          let suggested_label_name = suggestion.label_name
            || suggestion.label
            || (this.labels.find(label => label.id == suggestion.label_id) || {}).name
            || String(suggestion.label_id);
          let id = uuidV4();
          let color = [0,180,0]
          let annotation = new Annotation(id, 'point', suggestion.coords, this.parseSuggestionField(suggestion.confidence), suggested_label_name, color);
          this.addAnnotationClearSelection(annotation)
        }
        else if(suggestion.action === 'delete_annotation') {
          let annotations = this.annotations.filter(annotation => annotation.id !== annotation_suggestion.annotation_id)
          this.annotations = annotations
        }
        else if(suggestion.action === 'rename_label_annotation') {
          let suggested_label_name = suggestion.label_name
            || suggestion.label
            || (this.labels.find(label => label.id == suggestion.label_id) || {}).name
            || String(suggestion.label_id);
          let annotation_ids = this.annotations.map(annotation => annotation.id)
          let index = annotation_ids.indexOf(annotation_suggestion.annotation_id)
          if (index !== -1) {
            this.annotations = this.annotations.map((annotation, i) => {
              if (i === index) {
                annotation.label = suggested_label_name;
              }
              return annotation;
            });
          }
        }
      });
    },
    async toggleAssetAcceptSuggestions() {
      // if you don't toggle you want [items] with original annotations
      // if you toggle you want [items] with suggestions
    },
    
    accept_all_suggestions() {
      console.log('this part should accept all suggestions')
    },
  },
}
</script>

<style scoped>

</style>
